import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { useIsIssueViewModalOpen } from '@atlassian/jira-issue-view-modal-state/src/index.tsx';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/outlet/index.tsx';
import { useRovoExperienceAPIStore } from '@atlassian/rovo-experience-api';
import { useRovoButtonNode } from '../state/useRovoButtonNode.tsx';
import { useIsGlobalRovoButtonAvailableForRoute } from './useIsGlobalRovoButtonAvailableForRoute.tsx';
import { useShouldShowRovoButton } from './useShouldShowRovoButton.tsx';

export const GlobalAiRovoButton = (): React.JSX.Element | null => {
	const isRovoAvailableForRoute = useIsGlobalRovoButtonAvailableForRoute();
	const showRovoButton = useShouldShowRovoButton();
	const [isIssueViewModalOpen] = useIsIssueViewModalOpen();
	const { mode: rovoMode } = useRovoExperienceAPIStore();
	const [rovoButtonNode] = useRovoButtonNode();
	const shouldShowPlaceholder = isIssueViewModalOpen && rovoMode !== 'sidebar';

	if (!isRovoAvailableForRoute || !showRovoButton) {
		return null;
	}

	return (
		<JiraBottomRightCornerOutlet orderFromRight={0} id="floating-element-id">
			{shouldShowPlaceholder ? <Box aria-hidden xcss={styles.placeholder} /> : rovoButtonNode}
		</JiraBottomRightCornerOutlet>
	);
};

const styles = cssMap({
	placeholder: {
		width: '48px',
		height: '48px',
	},
});
